import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate, useOutletContext, useLocation } from "react-router-dom";
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";
import PatientInfoForm from "../Forms/PatientInfoForm";
import "../../Styles/patientform.css";

const EditPatientInfo = () => {
  const { patientId, caseId, visitId } = useParams();
  const {
    fetchPatientData,
    patientData,
    setPatientData,
    createNewVisit,
    doctorInfo
  } = usePatient();
  const { markSectionComplete } = useOutletContext() ;  
  const { verifyTokenAndRedirect } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    verifyTokenAndRedirect();

    const loadPatientData = async () => {
      try {
        console.log("Fetching patient data...");
        const data = await fetchPatientData(patientId, caseId, visitId);

        if (!data) {
          setError("Failed to load patient data");
          setLoading(false);
          return;
        }

        console.log("Fetched patient data:", data);

        // Create a new visit template with the fetched patient history
        //const visitTemplate = createNewVisit(patientId, caseId, visitId, data);

//        console.log("Created visit template:", visitTemplate);

//        Merge the visit template with fetched patient data
        const updatedPatientData = {
          ...patientData, ...data
        };



// Update specific keys without replacing the entire object
//        const updatedPatientData = updateNextedKeys(...patientData, ...data);

        console.log("Updated patient data with visit template:", updatedPatientData);

        setPatientData(updatedPatientData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching patient data:", error);
        setError(error.message);
        setLoading(false);
      }
    };

    loadPatientData();
  }, [patientId, caseId, visitId, fetchPatientData, createNewVisit]);

  const onSubmitHandler = (updatedPatientInfo) => {
    
  //   const updatedData = {
  //     ...patientData, 
  //     patientInfo: [{ ...updatedPatientInfo }] // Overwrite patientInfo while keeping other data unchanged
  // };
    
  const updatedData = {
    ...patientData, 
    patientInfo: patientData.patientInfo.map(info => ({
        ...info, // Keep existing patientInfo fields
        ...updatedPatientInfo,
        DOCTOR_ID: doctorInfo.MANDALI_ID,
        CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
    }))
};

  setPatientData(updatedData);
  markSectionComplete("info");
  if (location.pathname.startsWith("/addpatient")) {
    navigate("/addpatient/symptoms");
  } else if (location.pathname.startsWith("/visits")) {
    navigate(`/visits/${patientId}/${caseId}/${visitId}/symptoms`);
  } else {
    console.warn("Unknown route, no redirection");
  }
  };

  if (loading) return <div>Loading patient data...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      {patientData && (
        <PatientInfoForm
          initialValues={patientData}
          onSubmit={onSubmitHandler}
          enableReinitialize={true}
        />
      )}
    </div>
  );
};

export default EditPatientInfo;
